import {ERROR, START, SUCCESS} from "../../../../../constants/action-postfix";
import {DISEASED_MONTH_REQUEST} from "../diseasedMonthReducer";


const initialState = false;

export const diseasedMonthLoaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${DISEASED_MONTH_REQUEST}${START}`:
            return true;
        case `${DISEASED_MONTH_REQUEST}${SUCCESS}`:
            return false;
        case `${DISEASED_MONTH_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};